<template>
  <div>
    <main class="portada" id="portada">
     
       <video class="portada_video" autoplay preload muted  poster="http://cimogsys.espoch.edu.ec/geoportal_files/INTRO/INTRO.png">
        <source src="http://cimogsys.espoch.edu.ec/geoportal_files/INTRO/INTRO.mp4" type="video/mp4">
        </video> 
        <router-link to="/registro"  class="portada_ingresar" >
        </router-link>
     
     

<!-- 
      <div class="encabezado">
           <img class="encabezado__logo"></img>
           <h2 class="encabezado__nombre">Cimogsys</h2>
      </div> -->

 <!--      <div class="datos__izquierda">
        <h3 class="datos__izquierda__nombre">Sistema de Gestion de Informacion Alpa</h3>
       
        <div class="datos__izquierda__separador"></div>
        <div class="datos__izquierda__redes">
             <a href="#" class="redes__item"> 
                <img class="redes__img" src="../assets/logo.png">
             </a>
             <a href="#" class="redes__item"> 
                <img class="redes__img" src="../assets/logo.png">
             </a>
             <a href="#" class="redes__item"> 
                <img class="redes__img" src="../assets/logo.png">
             </a>
             <a href="#" class="redes__item"> 
                <img class="redes__img" src="../assets/logo.png">
             </a>
             
        </div>
      </div> -->
     


      <!-- <div class="pie">
         <div class="pie__boton"  @click.prevent="portadaState"></div>
      </div> -->



    </main>
  </div>
</template>

<script>

import store from '../store'


export default {
  name: 'portada',
  data: function(){
    return {
    }
  },

  methods:{
    portadaState () {
      store.commit('INACTIVEPORTADA')
    },
  },
}
</script>
<style  lang="scss"  scoped src="../sass/portada.scss"></style>




// WEBPACK FOOTER //
// src/components/portada.vue